<div class="row_1">
    <div>
        <label class="label tab-heading"  (click)="openRouteLevel('reasonId')">Reason IDs</label>
        <label class="label tab-heading titlered">Daily Expedite Targets</label>
        <label class="label tab-heading" (click)="openRouteLevel('rootCause')">Root Cause Dropdown</label>
    </div>
    <div class="top_grid_agg">
        <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
        </app-notification-message>
 <div style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;margin-right: 17px;padding-top: 5px;">
      <button class="primarybutton" (click)="refreshData()">REFRESH</button>
          <button class="primarybutton" (click)="copyDialog()">COPY ALL</button>
      <button class="primarybutton" (click)="addexpedite()">ADD</button>
      <button class="primarybutton" (click)="onBtExport()">EXPORT</button>
    </div>
     
    <div class="grid-agg" style="margin-top: 8px">
            
            <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
                'width':'100%'}" id="LIOS-GRID" class="ag-theme-balham" [theme]="'legacy'"
                (gridReady)="onGridReady($event);" (window:resize)="sizeToFit()" [animateRows]="true"
                [defaultColDef]="defaultColDef" [columnDefs]="columnDefs" [rowData]="displayRowData"
                [gridOptions]="gridOptions" [context]="context" [pagination]="true" [paginationPageSize]="paginationPageSize"
                [icons]="icons">
            </ag-grid-angular>
         

              <div class="custom-pagination" *ngIf="totalRecords > 0">
        <div class="left">
          <span class="records-per-page">
            <span>Records/Page : </span>
            <select [(ngModel)]="rpPage" (change)="rppChanged($event)">
              <option *ngFor="let size of pgDropDown" [value]="size.value">
                {{ size.value }}
              </option>
            </select>
          </span>
        </div>
        <div class="right">
          <span class="viewing-records">
            <span class="w-600">{{ sRecord }}</span> to
            <span class="w-600">{{ eRecord }}</span> of
            <span class="w-600">{{ totalRecords }}</span>
            <button
              (click)="goToFirstPage()"
              [disabled]="getCurrentPage() === true"
            >
              <i
                class="fa-solid fa-backward-fast"
                [ngStyle]="
                  getCurrentPage() === true
                    ? { color: 'gray' }
                    : { color: '#1394f6' }
                "
              ></i>
            </button>
            <button
              (click)="goToPreviousPage()"
              [disabled]="getCurrentPage() === true"
            >
              <i
                class="fa-solid fa-backward-step"
                [ngStyle]="
                  getCurrentPage() === true
                    ? { color: 'gray' }
                    : { color: '#1394f6' }
                "
              ></i>
            </button>
            <span
              >Page <span class="w-600">{{ cPage }}</span> of
              <span class="w-600">{{ tPage }}</span></span
            >
            <button (click)="goToNextPage()" [disabled]="isLastPage() === true">
              <i
                class="fa-solid fa-forward-step"
                [ngStyle]="
                  isLastPage() === true
                    ? { color: 'gray' }
                    : { color: '#1394f6' }
                "
              ></i>
            </button>
            <button (click)="goToLastPage()" [disabled]="isLastPage() === true">
              <i
                class="fa-solid fa-forward-fast"
                [ngStyle]="
                  isLastPage() === true
                    ? { color: 'gray' }
                    : { color: '#1394f6' }
                "
              ></i>
            </button>
          </span>
        </div>
      </div>

           
        </div>
    </div>
</div>